<template>
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
    <Row class="loading" :style="loading==true ? '' : 'display:none'">
      <Col class="demo-spin-col" span="8">
        <Spin fix>
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>加载中</div>
        </Spin>
      </Col>
    </Row>
    <div>
      <el-input size="mini" class="search" placeholder="输入票据号码" v-model="bill_number" clearable></el-input>
      <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
    </div>
    <div>房产：{{homeName}}</div>
    <v-divider></v-divider>
    <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">ID</th>
          <th class="text-left">客户</th>
          <th class="text-left">房产</th>
          <th class="text-left">类型</th>
          <th class="text-left">收据单号</th>
          <th class="text-left">票据金额</th>
          <th class="text-left">操作员</th>
          <th class="text-left">操作时间</th>
          <th class="text-left">操作</th>
        </tr>
        </thead>
        <tbody>
        <tr class="text1" v-for="item in data">
          <td >{{item.id}}</td>
          <td >{{item.name}}</td>
          <td >{{item.house}}</td>
          <td >{{item.type_name}}</td>
          <td >{{item.bill_number}}</td>
          <td >{{item.money}}</td>
          <td >{{item.login_name}}</td>
          <td >{{item.date}}</td>
          <td ><div style="color: #409EFF;cursor: pointer;" @click="select(item)">查看</div></td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="data">
      <Page :total="count" :page-size="pageSize" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
    <Modal
        v-model="modal1"
        :ok-text="anxiu"
        width="800"
        title="票据">
        <div>
          <order :data="bill"></order>
        </div>
    </Modal>
    <Modal
        v-model="modal2"
        :ok-text="anxiu"
        width="800"
        title="票据">
        <div>
          <deposit :data="bill1"></deposit>
        </div>
    </Modal>
    <Modal
        v-model="modal3"
        :ok-text="anxiu"
        width="800"
        title="票据">
        <div>
          <advance :data="bill2"></advance>
        </div>
    </Modal>
  </div>
</div>

</template>

<script>
import ErpTree from "../Common/erp-tree";
import imgurl from "../../../assets/js/imgurl.js";
import order from "./bill/order.vue";
import deposit from "./bill/deposit.vue";
import advance from "./bill/advance.vue";
export default {
  name: 'FinanceBill',
  components: {
    ErpTree,
    order,
    deposit,
    advance
  },
  data () {
    return {
      cs:1,
      modal1: false,
      modal2: false,
      modal3: false,
      loading:false,
      loadingModal:true,
      optionsHouse:[],
      bill_number:'',
      options: [],
      pid: '',
      data: '',
      count:0,
      pageSize:12,
      anxiu:'关闭',
      homeName:'',
      types:2,
      bill:[],
      bill1:[],
      bill2:[],
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    this.pid = this.$route.query.pid;
    this.homeName = this.$route.query.homeName;

    this.change(1);
    //项目列表
    this.$myhttp.get('admin/common/pindex',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.options = backdata.data.data;
    });
  },
  //事件
  methods: {
    //获得当前多少页,分页
    change(page){
      if(this.pid == ""){
        if(this.types == 1){
          this.$Message.error('请选择房产');
        }
        return false;
      }
      this.loading = true;
      this.$myhttp.get('admin/bill/index?page='+ page + '&pid='+ this.pid +"&homeName="+this.homeName+"&bill_number="+this.bill_number,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data.code == 200){
            let data = backdata.data.data;
            this.data = data.data;
            this.count = data.count;
            this.pageSize = data.pageSize;
          }
          this.loading = false;
      });
    },
    //搜索
    searchs(){
      this.types = 1;
      this.change(1);
    },
    //查看票据
    select(item){
      //console.log(item);
      this.$myhttp.get('admin/bill/select?id='+item.id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          if(item.type == 1){
            this.bill = backdata.data;
            this.modal1 = true;
          }
          if(item.type == 2){
            this.bill1 = backdata.data;
            this.modal2 = true;
          }
          if(item.type == 3){
            this.bill2 = backdata.data;
            this.modal3 = true;
          }
      });
    },

    //弹窗不要关闭
    loadingModals(){
      let _this = this;
      _this.loadingModal=false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10);
    },
    nodeClick(data){
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      this.pid = data.tree[0].id;
      this.homeName=tree_str;
      this.change(1);
    }
  },
  watch: {

  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
.demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.demo-spin-col{
    height: 100px;
    position: relative;
}
.loading{
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90%;
  width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Finance/bill.vue